/**
 * Preserved-legacy commands (carve-out 2) print this one-line notice on stderr.
 *
 * List is the source of truth for the zero-legacy grep exclusion (Task 44):
 *   remove, rollback, connect, disconnect, builds, hooks, ssh, dev,
 *   doctor, usage, support, feedback
 *
 * `pull` was removed from this list: it is no longer a legacy verb but a
 * shipped alias of `pickup` (mega-plan v2 §1, §6, Decision A).
 *
 * Tracked: docs/backlog/010-v2-runtime-operations.md
 */
export const PRESERVED_LEGACY_COMMANDS = [
  'remove', 'rollback', 'connect', 'disconnect', 'builds',
  'hooks', 'ssh', 'dev', 'doctor', 'usage', 'support', 'feedback',
] as const;

export function printLegacyNotice(): void {
  if (process.env.CLOUDGRID_SUPPRESS_LEGACY_NOTICE === '1') return;
  process.stderr.write(`Note: This command uses legacy APIs that will be retired. A v2 replacement is planned.\n`);
}
